import { useEffect, useRef, useState } from 'react';
import socket from '../socket/socket';
import { IOrder } from '../interfaces';

interface IGetOrderPayload {
    order: IOrder;
}

export const useOrder = () => {
    const socketRef: any = useRef(null);

    const [order, setOrder] = useState<IOrder | null>(null);

    useEffect(() => {
        socketRef.current = socket;

        socketRef.current.on('order:get', (payload: IGetOrderPayload) => {
            setOrder(payload.order);
        });

        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    return { order };
};
